import { pathnameFromUrl } from '../../../../helpers/url_helpers';

const FINISHES_TAB_HEADING = 'Finishes';
const PRODUCT_HIGHLIGHTS_REGION = 'Product Highlights';
const FLEETWOOD_PREFIX = 'fleetwoodusa';

const destinationFromHref = href => {
  const segments = pathnameFromUrl(href).split('/').filter(Boolean);
  if (segments.length < 2) return undefined;
  const [penultimate, last] = segments.slice(-2);
  return `${FLEETWOOD_PREFIX} | ${penultimate} | ${last}`;
};

const trackFleetwoodFinishesCta = (container, { buildType } = {}) => {
  if (!container) return undefined;

  const isFleetwood = buildType === 'Product::Fleetwood';
  const section = container.closest('[data-am-region]');
  if (!isFleetwood || section?.dataset?.amRegion !== PRODUCT_HIGHLIGHTS_REGION) return undefined;

  const applyAttrs = () => {
    const tabEl = container.querySelector(`[data-tab-heading="${FINISHES_TAB_HEADING}"]`);
    if (!tabEl) return;
    tabEl.querySelectorAll('a').forEach(link => {
      if (link.closest('p')) return;
      const destination = destinationFromHref(link.getAttribute('href'));
      if (!destination) return;
      link.setAttribute('data-track', 'learn-more');
      link.setAttribute('data-track-destination', destination);
    });
  };
  applyAttrs();

  // Re-tag the CTA whenever the Finishes tab content (re)renders.
  const observer = new MutationObserver(applyAttrs);
  observer.observe(container, { childList: true, subtree: true });

  return () => observer.disconnect();
};

export default trackFleetwoodFinishesCta;
